// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1v-zm","actions":"GroupTable_actions__2zb2Z","deleteModalFooter":"GroupTable_deleteModalFooter__1QzsX"};